<div mat-dialog-title>
  {{modalData.id + ' : ' + modalData.name}}
  <div style="float: right; margin-top: -5px;">
    <button mat-icon-button *ngIf="!modalData.readOnly && !isEdit">
      <img src="../../../../assets/edit-w.png" style="width: 20px;" (click)="toggleEdit()">
    </button>
    <button mat-icon-button *ngIf="!modalData.readOnly && isEdit">
      <img src="../../../../assets/visibility.png" style="width: 20px;" (click)="toggleEdit()">
    </button>
    <button mat-icon-button *ngIf="modalData.status !== 'Deactivate'">
      <img src="../../../../assets/delete.png" style="width: 20px;" (click)="delete(modalData.id, modalData.role)">
    </button>
    <button mat-button *ngIf="modalData.status === 'Deactivate'" style="top:4px;"
      (click)="reactivate(modalData.id, modalData.role)">
      <img src="../../../../assets/reactivate.png" style="width: 25px;" class="mr-1">
      กู้คืนบัญชี
    </button>

    <button mat-icon-button [mat-dialog-close]="true" (click)="closeModal()">
      <img src="../../../../assets/close-white.png" style="width: 12px;">
    </button>
  </div>
</div>
<br />

<mat-dialog-content *ngIf="!isEdit && modalData" class="mat-typography" [style]="modalData.customStyle"
  [class.mb-4]="!isEdit">

  <div *ngIf="modalData.role === 'user'">
    <div class="form-group row">
      <label class="col-5 offset-2"><b>ชื่อผู้ใช้งาน</b></label>
      <label class="col-5">{{ modalData.row.USERNAME }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>อีเมล</b></label>
      <label class="col-5">{{ modalData.row.EMAIL }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>เพศ</b></label>
      <label class="col-5">{{ modalData.row.GENDER }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>วัน/เดือน/ปีเกิด</b></label>
      <label *ngIf="date" class="col-5">{{ modalData.row.DATE_OF_BIRTH | date:'full' }} ({{age}} ปี)</label>
      <label *ngIf="!date" class="col-5">-</label>
    </div>
    <p class="text-center"><b>ประวัติการใช้งาน</b></p>
    <div class="row justify-content-center">
      <lifedi-btn class="col text-center" lable="E-learning" (click)="openHistory('course')" [customStyle]="btnHistoryStyle"></lifedi-btn>
      <lifedi-btn class="col text-center" lable="แบบทดสอบ" (click)="openHistory('measure')" [customStyle]="btnHistoryStyle"></lifedi-btn>
      <lifedi-btn class="col text-center" lable="กิจกรรม" (click)="openHistory('activity')" [customStyle]="btnHistoryStyle"></lifedi-btn>
      <lifedi-btn class="col text-center" lable="วิจัย" (click)="openHistory('research')" [customStyle]="btnHistoryStyle"></lifedi-btn>
      <lifedi-btn class="col text-center" lable="Payment" (click)="openHistory('payment')" [customStyle]="btnHistoryStyle"></lifedi-btn>
    </div>
  </div>


  <div *ngIf="modalData.role === 'teacher' || modalData.role === 'psychologist'">
    <div class="form-group row">
      <label class="col-5 offset-2"><b>ชื่อผู้ใช้งาน</b></label>
      <label class="col-5">{{ modalData.row.USERNAME }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>อีเมล</b></label>
      <label class="col-5">{{ modalData.row.EMAIL }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>เพศ</b></label>
      <label class="col-5">{{ modalData.row.GENDER }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>วัน/เดือน/ปีเกิด</b></label>
      <label *ngIf="date" class="col-5">{{ modalData.row.DATE_OF_BIRTH | date:'full' }} ({{age}} ปี)</label>
      <label *ngIf="!date" class="col-5">-</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>เบอร์โทรศัพท์</b></label>
      <label class="col-5">{{ modalData.row.PHONENUMBER | phoneNO}}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>เชี่ยวชาญ</b></label>
      <div class="col-5 scroll"
        style="height: 150px; overflow-y: auto; background-color: #F5F5F5; border: 1px solid #ccc; border-radius: 5px;">
        <div class="row" style="padding: 5px;">
          <mat-chip-list *ngFor="let exp of modalData.row.EXPERTIES" aria-label="expertie">
            <mat-chip style="margin: 10px;">{{ exp.EXPERTIE_NAME }}</mat-chip>
          </mat-chip-list>
        </div>
      </div>
    </div>
    <p class="text-center"><b>ประวัติ</b></p>
    <div id="_content" [innerHtml]="personalDescription"></div>
  </div>


  <div *ngIf="modalData.role === 'admin'">
    <div class="form-group row">
      <label class="col-5 offset-2"><b>ชื่อผู้ใช้งาน</b></label>
      <label class="col-5">{{ modalData.row.USERNAME }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>อีเมล</b></label>
      <label class="col-5">{{ modalData.row.EMAIL }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>เพศ</b></label>
      <label class="col-5">{{ modalData.row.GENDER }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>วัน/เดือน/ปีเกิด</b></label>
      <label *ngIf="date" class="col-5">{{ modalData.row.DATE_OF_BIRTH | date:'full' }} ({{age}} ปี)</label>
      <label *ngIf="!date" class="col-5">-</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-2"><b>เบอร์โทรศัพท์</b></label>
      <label class="col-5">{{ modalData.row.PHONENUMBER | phoneNO}}</label>
    </div>
  </div>
</mat-dialog-content>


<mat-dialog-content *ngIf="isEdit && modalData" class="mat-typography" [style]="modalData.customStyle">
  <form *ngIf="modalData.role === 'user'" [formGroup]="userAccountForm">
    <div class="form-group row">
      <label class="col-5 offset-1"><b>สถานะ</b></label>
      <label class="col-5">
        <mat-slide-toggle *ngIf="!modalData.readOnly" color="primary" [(ngModel)]="modalData.digitStatus"
          [ngModelOptions]="{standalone: true}" (change)="changeStatus($event)">
        </mat-slide-toggle>
        <mat-slide-toggle *ngIf="modalData.readOnly" disabled color="primary" [checked]="modalData.digitStatus"
          (change)="changeStatus($event)">
        </mat-slide-toggle>
      </label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>ชื่อผู้ใช้งาน</b></label>
      <label class="col-5">{{ modalData.row.USERNAME }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>อีเมล</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Email" formControlName="email" autocomplete="off"
        [ngModel]="modalData.row.EMAIL">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เพศ</b></label>
      <label class="col-5">{{ modalData.row.GENDER }}</label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>วัน/เดือน/ปีเกิด</b></label>
      <label *ngIf="date" class="col-5">{{ modalData.row.DATE_OF_BIRTH | date:'full' }} ({{age}} ปี)</label>
      <label *ngIf="!date" class="col-5">-</label>
    </div>
  </form>


  <form *ngIf="modalData.role === 'teacher'" [formGroup]="teacherAccountForm">
    <div class="form-group row">
      <label class="col-5 offset-1"><b>สถานะ</b></label>
      <label class="col-5">
        <mat-slide-toggle *ngIf="!modalData.readOnly" color="primary" [(ngModel)]="modalData.digitStatus"
          [ngModelOptions]="{standalone: true}" (change)="changeStatus($event)">
        </mat-slide-toggle>
        <mat-slide-toggle *ngIf="modalData.readOnly" disabled color="primary" [checked]="modalData.digitStatus"
          (change)="changeStatus($event)">
        </mat-slide-toggle>
      </label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>ชื่อผู้ใช้งาน</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Username" formControlName="username" autocomplete="off"
        [ngModel]="modalData.row.USERNAME">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>อีเมล</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Email" formControlName="email" autocomplete="off"
        [ngModel]="modalData.row.EMAIL">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เพศ</b></label>
      <select class="custom-select col-5" id="gender" formControlName="gender" [ngModel]="modalData.row.GENDER">
        <option value="ชาย">ชาย</option>
        <option value="หญิง">หญิง</option>
        <option value="ไม่ระบุ">ไม่ระบุ</option>
      </select>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>วัน/เดือน/ปีเกิด</b></label>
      <input type="text" class="form-control col-5" id="dateOfBirth" formControlName="dateOfBirth" bsDatepicker
        autocomplete="off" autocomplete="off" [ngModel]="date" [(bsValue)]="date" value="{{ date | date:'DD/MM/YYYY' }}"
        [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เบอร์โทรศัพท์</b></label>
      <input type="text" class="form-control col-5" id="phoneNO" formControlName="phoneNO" MaxLength="10"
        [ngModel]="modalData.row.PHONENUMBER">
    </div>
    <div *ngIf="tf.phoneNO.touched && tf.phoneNO.invalid">
      <div *ngIf="tf.phoneNO.errors.required" class="text-danger text-center">กรุณาใส่เบอร์โทรศัพท์</div>
      <div *ngIf="tf.phoneNO.errors.pattern" class="text-danger text-center">กรุณาใส่เบอร์โทรศัพท์จำนวน 9-10 หลัก
      </div>
    </div>
  </form>
  <div class="form-group row" *ngIf="modalData.role === 'teacher'">
    <label class="col-5 offset-1"><b>เชี่ยวชาญ</b></label>

    <nz-select nzMode="multiple" nzPlaceHolder="โปรดเลือกความเชี่ยวชาญ" [(ngModel)]="modalData.row.EXPERTIES" #exp
      class="text-left" [change]="getSelectedItem(exp, teacherAccountForm)" [compareWith]="compareFn" class="col-5 "
      style="width: 100%;">
      <nz-option *ngFor="let exp of experties" [nzLabel]="exp.EXPERTIE_NAME" [nzValue]="exp">
      </nz-option>
    </nz-select>
  </div>
  <form *ngIf="modalData.role === 'teacher'" [formGroup]="teacherAccountForm">
    <p class="text-center"><b>ประวัติ</b>
      <lifedi-require></lifedi-require>
    </p>
    <div class="row">
      <div class="col-12" style="padding-left: 30px;  margin-bottom: 10px;">
        <angular-editor id="_content" formControlName="description" [config]="editorConfig"
          [(ngModel)]="modalData.row.PERSONAL_DESCRIPTION">
        </angular-editor>
      </div>
    </div>
  </form>


  <form *ngIf="modalData.role === 'psychologist'" [formGroup]="psychologistAccountForm">
    <div class="form-group row">
      <label class="col-5 offset-1"><b>สถานะ</b></label>
      <label class="col-5">
        <mat-slide-toggle *ngIf="!modalData.readOnly" color="primary" [(ngModel)]="modalData.digitStatus"
          [ngModelOptions]="{standalone: true}" (change)="changeStatus($event)">
        </mat-slide-toggle>
        <mat-slide-toggle *ngIf="modalData.readOnly" disabled color="primary" [checked]="modalData.digitStatus"
          (change)="changeStatus($event)">
        </mat-slide-toggle>
      </label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>ชื่อผู้ใช้งาน</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Username" formControlName="username" autocomplete="off"
        [ngModel]="modalData.row.USERNAME">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>อีเมล</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Email" formControlName="email" autocomplete="off"
        [ngModel]="modalData.row.EMAIL">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เพศ</b></label>
      <select class="custom-select col-5" id="gender" formControlName="gender" [ngModel]="modalData.row.GENDER">
        <option value="ชาย">ชาย</option>
        <option value="หญิง">หญิง</option>
        <option value="ไม่ระบุ">ไม่ระบุ</option>
      </select>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>วัน/เดือน/ปีเกิด</b></label>
      <input type="text" class="form-control col-5" id="dateOfBirth" formControlName="dateOfBirth" bsDatepicker
        autocomplete="off" [ngModel]="date" [(bsValue)]="date" value="{{ date | date:'DD/MM/YYYY' }}"
        [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เบอร์โทรศัพท์</b></label>
      <input type="text" class="form-control col-5" id="phoneNO" formControlName="phoneNO" MaxLength="10"
        [(ngModel)]="modalData.row.PHONENUMBER">
    </div>
    <div *ngIf="pf.phoneNO.touched && pf.phoneNO.invalid">
      <div *ngIf="pf.phoneNO.errors.required" class="text-danger text-center">กรุณาใส่เบอร์โทรศัพท์</div>
      <div *ngIf="pf.phoneNO.errors.pattern" class="text-danger text-center">กรุณาใส่เบอร์โทรศัพท์จำนวน 9-10 หลัก
      </div>
    </div>
  </form>
  <div class="form-group row" *ngIf="modalData.role === 'psychologist'">
    <label class="col-5 offset-1"><b>เชี่ยวชาญ</b></label>

    <nz-select nzMode="multiple" nzPlaceHolder="โปรดเลือกความเชี่ยวชาญ" [(ngModel)]="modalData.row.EXPERTIES" #exp
      class="text-left" [change]="getSelectedItem(exp, psychologistAccountForm)" [compareWith]="compareFn"
      class="col-5 " style="width: 100%;">
      <nz-option *ngFor="let exp of experties" [nzLabel]="exp.EXPERTIE_NAME" [nzValue]="exp">
      </nz-option>
    </nz-select>
  </div>
  <form *ngIf="modalData.role === 'psychologist'" [formGroup]="psychologistAccountForm">
    <p class="text-center"><b>ประวัติ</b>
      <lifedi-require></lifedi-require>
    </p>
    <div class="row">
      <div class="col-12" style="padding-left: 30px; margin-bottom: 10px;">
        <angular-editor id="_content" formControlName="description" style="background-color: white;"
          [config]="editorConfig" [(ngModel)]="modalData.row.PERSONAL_DESCRIPTION">
        </angular-editor>
      </div>
    </div>
  </form>


  <form *ngIf="modalData.role === 'admin'" [formGroup]="adminAccountForm">
    <div class="form-group row">
      <label class="col-5 offset-1"><b>สถานะ</b></label>
      <label class="col-5">
        <mat-slide-toggle *ngIf="!modalData.readOnly" color="primary" [(ngModel)]="modalData.digitStatus"
          [ngModelOptions]="{standalone: true}" (change)="changeStatus($event)">
        </mat-slide-toggle>
        <mat-slide-toggle *ngIf="modalData.readOnly" disabled color="primary" [checked]="modalData.digitStatus"
          (change)="changeStatus($event)">
        </mat-slide-toggle>
      </label>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>ชื่อผู้ใช้งาน</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Username" formControlName="username" autocomplete="off"
        [ngModel]="modalData.row.USERNAME">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>อีเมล</b>
        <lifedi-require></lifedi-require>
      </label>
      <input type="text" class="form-control col-5" id="Email" formControlName="email" autocomplete="off"
        [ngModel]="modalData.row.EMAIL">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เพศ</b></label>
      <select class="custom-select col-5" id="gender" formControlName="gender" [ngModel]="modalData.row.GENDER">
        <option value="ชาย">ชาย</option>
        <option value="หญิง">หญิง</option>
        <option value="ไม่ระบุ">ไม่ระบุ</option>
      </select>
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>วัน/เดือน/ปีเกิด</b></label>
      <input type="text" class="form-control col-5" id="dateOfBirth" formControlName="dateOfBirth" bsDatepicker
        autocomplete="off" [ngModel]="date" [(bsValue)]="date" value="{{ date | date:'DD/MM/YYYY' }}"
        [bsConfig]="{ containerClass: 'theme-red', showWeekNumbers: false }">
    </div>
    <div class="form-group row">
      <label class="col-5 offset-1"><b>เบอร์โทรศัพท์</b></label>
      <input type="text" class="form-control col-5" id="phoneNO" formControlName="phoneNO" MaxLength="10"
        [ngModel]="modalData.row.PHONENUMBER">
    </div>
    <div *ngIf="af.phoneNO.touched && af.phoneNO.invalid">
      <div *ngIf="af.phoneNO.errors.required" class="text-danger text-center">กรุณาใส่เบอร์โทรศัพท์</div>
      <div *ngIf="af.phoneNO.errors.pattern" class="text-danger text-center">กรุณาใส่เบอร์โทรศัพท์จำนวน 9 หรือ 10 หลัก
      </div>
    </div>
  </form>
  <!-- <div *ngIf="msgError" class="row mt-3">
    <span class="text-danger" style="margin: 0 auto;"> {{ msgError }} </span>
  </div> -->
</mat-dialog-content>


<mat-dialog-actions align="center" *ngIf="modalData.role === 'user' && isEdit" class="mb-2">
  <button mat-button class="lifedi-btn-success" *ngIf="isEdit && userAccountForm.valid" (click)="actionFunction()">
    {{ modalData.actionBtnText }}</button>
  <button mat-button *ngIf="isEdit && !userAccountForm.valid" disabled="true">
    {{ modalData.actionBtnText }}</button>
</mat-dialog-actions>

<mat-dialog-actions align="center" *ngIf="modalData.role === 'teacher' && isEdit" class="mb-2">
  <button mat-button class="lifedi-btn-success" *ngIf="isEdit && teacherAccountForm.valid" (click)="actionFunction()">
    {{ modalData.actionBtnText }}</button>
  <button mat-button *ngIf="isEdit && !teacherAccountForm.valid" disabled="true">
    {{ modalData.actionBtnText }}</button>
</mat-dialog-actions>

<mat-dialog-actions align="center" *ngIf="modalData.role === 'psychologist' && isEdit" class="mb-2">
  <button mat-button class="lifedi-btn-success" *ngIf="isEdit && psychologistAccountForm.valid"
    (click)="actionFunction()">
    {{ modalData.actionBtnText }}</button>
  <button mat-button *ngIf="isEdit && !psychologistAccountForm.valid" disabled="true">
    {{ modalData.actionBtnText }}</button>
</mat-dialog-actions>

<mat-dialog-actions align="center" *ngIf="modalData.role === 'admin' && isEdit" class="mb-2">
  <button mat-button class="lifedi-btn-success" *ngIf="isEdit && adminAccountForm.valid" (click)="actionFunction()">
    {{ modalData.actionBtnText }}</button>
  <button mat-button *ngIf="isEdit && !adminAccountForm.valid" disabled="true">
    {{ modalData.actionBtnText }}</button>
</mat-dialog-actions>
